(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  /* 1) Header cart icon: on mobile go straight to the cart page (skip the drawer). */
  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var link = e.target && e.target.closest ? e.target.closest('#cart-icon-bubble') : null;
    if (!link) return;
    e.stopPropagation();
    e.preventDefault();
    window.location.href = link.getAttribute('href') || '/cart';
  }, true);
  /* 2) After any successful add-to-cart on mobile, land on the cart page. */
  var origFetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = (typeof a === 'string' ? a : (a && a.url) || '') || '';
    var p = origFetch.apply(this, arguments);
    if (mq.matches && url.indexOf('/cart/add') !== -1) {
      p.then(function (res) {
        if (res && res.ok) {
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          setTimeout(function () { window.location.href = root + 'cart'; }, 120);
        }
      }).catch(function () {});
    }
    return p;
  };
})();
